var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    [
      _vm.modelData
        ? [
            _vm.imageField
              ? _c(
                  "q-card-media",
                  [
                    _c("grid-cell-image", {
                      attrs: {
                        col: _vm.imageField,
                        value: _vm.modelData[_vm.imageField.field]
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(props) {
                              return _c(
                                "div",
                                {},
                                [
                                  _c(
                                    "q-parallax",
                                    {
                                      attrs: {
                                        src: props.src,
                                        height: 250,
                                        speed: 0.2
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "loading" },
                                          slot: "loading"
                                        },
                                        [_vm._v("Loading...")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          }
                        ],
                        null,
                        false,
                        1218542920
                      )
                    }),
                    _c(
                      "q-card-title",
                      { attrs: { slot: "overlay" }, slot: "overlay" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("shvl")(_vm.modelData, _vm.titleFieldPath)
                            ) +
                            "\n        "
                        ),
                        _vm.subTitleFieldPath
                          ? _c(
                              "span",
                              { attrs: { slot: "subtitle" }, slot: "subtitle" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("shvl")(
                                        _vm.modelData,
                                        _vm.subTitleFieldPath
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              : _c("q-card-title", { staticClass: "title relative-position" }, [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("shvl")(_vm.modelData, _vm.titleFieldPath)
                        ) +
                        "\n        "
                    )
                  ])
                ]),
            _c(
              "q-card-main",
              [
                _c(
                  "q-list",
                  { attrs: { "no-border": "" } },
                  _vm._l(_vm.cardFields, function(column) {
                    return _c(
                      "q-item",
                      { key: column.field, staticClass: "q-body-1" },
                      [
                        _c("q-item-side", { attrs: { color: "primary" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(column.label) +
                              "\n          "
                          )
                        ]),
                        _c(
                          "q-item-main",
                          {
                            staticClass: "text-info",
                            attrs: { align: "left" }
                          },
                          [
                            _c(_vm._f("componentIs")(column), {
                              tag: "component",
                              staticClass: "text-info",
                              attrs: {
                                column: column,
                                value: _vm.modelData[column.field],
                                template: "raw",
                                resource: _vm.resource,
                                row: _vm.modelData,
                                id: _vm.modelData.id
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _c("q-card-separator"),
            _vm._t(
              "actions",
              function() {
                return [
                  _c(
                    "q-card-actions",
                    { attrs: { align: "between" } },
                    [
                      _c("q-btn", {
                        attrs: {
                          color: "primary",
                          flat: "",
                          label: "edit",
                          icon: "edit"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.push(
                              _vm.baseRoute + "/edit/" + _vm.modelData.id
                            )
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          small: "",
                          color: "negative",
                          icon: "delete"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(_vm.modelData.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              },
              { modelData: _vm.modelData, baseRoute: _vm.baseRoute }
            )
          ]
        : _vm._e(),
      _c("q-inner-loading", { attrs: { visible: _vm.loading } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }